<template>
  <v-container grid-list-md page>
    <v-flex>
      <v-layout row wrap class="mb-4">
        <v-flex xs12 sm4 md3>
          <v-card>
            <v-card-media
              v-if="artist_data.main_large_image == null"
              src="/static/unknown.png"
              width="280px"
              height="280px"
              contain
            ></v-card-media>
            <v-card-media
              v-else
              :src="artist_data.main_large_image"
              width="280px"
              height="280px"
              contain
            ></v-card-media>
          </v-card>
        </v-flex>
        <v-flex xs12 sm8 md9>
          <v-jumbotron height="auto">
            <v-container fill-height>
              <v-layout>
                <v-flex>
                  <h1 class="artistName mb-2">{{ artist_data.artist_name }}</h1>
                  <p class="artistName_sub">{{ artist_data.artist_name_kana }}</p>
                  <v-divider class="my-3"></v-divider>
                  <p>{{ artist_data.profile }}</p>
                  <a v-if="artist_data.link_homepage != null" v-bind:href="artist_data.link_homepage" target="_blank">
                    <v-avatar size="40px">
                      <img src="/static/icon/webpage_icon.png" alt="ホームページ">
                    </v-avatar>
                  </a>
                  <a v-if="artist_data.link_facebook != null" v-bind:href="artist_data.link_facebook" target="_blank">
                    <v-avatar size="40px">
                      <img src="/static/icon/facebook_icon.png" alt="John">
                    </v-avatar>
                  </a>
                  <a v-if="artist_data.link_twitter != null" v-bind:href="artist_data.link_twitter" target="_blank">
                    <v-avatar size="40px">
                      <img src="/static/icon/twitter_icon.png" alt="John">
                    </v-avatar>
                  </a>
                  <a v-if="artist_data.link_blog != null" v-bind:href="artist_data.link_blog" target="_blank">
                    <v-avatar size="40px">
                      <img src="/static/icon/blog_icon.png" alt="John">
                    </v-avatar>
                  </a>
                </v-flex>
              </v-layout>
            </v-container>
          </v-jumbotron>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
          <p class="title my-4 title_border">プロフィール</p>
          <p class="mb-5" v-html="artist_data.main_list_comment" style="white-space: pre-line;"></p>
          <p class="title my-4 title_border">実績</p>
          <p v-html="artist_data.main_comment" style="white-space: pre-line;"></p>
        </v-flex>
      </v-layout>
      <v-divider class="my-3"></v-divider>
      <v-list two-line>
        <v-list-tile v-for="(product, index) in artist_products" :key="product.product_id" avatar class="itemDivider">
          <play-btn
            :itemIndex=parseInt(index)
            :itemTitle="product.name"
            :itemArtist="artist_data.artist_name"
            :itemSrc="product.mp3"
            :itemProductId="product.product_id"
            :musicPlayerType="'artist'"
          />
          <v-list-tile-content>
            <v-list-tile-title>{{ product.name }}</v-list-tile-title>
          </v-list-tile-content>
          <v-spacer></v-spacer>
          <lyrics
            :title="product.name"
            :artist="artist_data.artist_name"
            :lyrics="product.lyrics"
            :introduction="product.introduction"
          />
          <more-btn
            :addIsumBtn="false"
            :addCommentBtn="false"
            :addMusicBtn="false"
            :addListBtn="true"
            :addFavoriteBtn="true"
            :deleteListBtn="false"
            :productId="product.product_id"
          />
        </v-list-tile>
      </v-list>
    </v-flex>
  </v-container>
</template>

<script>
import ArtistService from '@/components/services/ArtistService.vue'
import MoreBtn from '@/components/MoreBtn.vue'
import Lyrics from '@/components/Lyrics.vue'
import PlayBtn from '@/components/PlayBtn.vue'
export default {
  name: 'ArtistDetail',
  data: () => ({
    artist_id: null,
    artist_data: {},
    artist_products: {}
  }),
  props: {
    source: String
  },
  created () {
    this.artist_id = this.$route.params.id
    this.logging(this.artist_id)
    this.getArtistDetail(this.artist_id)
    this.getArtistTunes(this.artist_id)
  },
  methods: {
    handleClick: function () {
      console.log('ボタン押下')
    },
    /**
     * artistIdを使用してアーティストの詳細を取得
     **/
    getArtistDetail (artistId) {
      this.logging('methods: getArtistDetail()')
      var transactionId = this.$store.state.transactionId
      ArtistService.findArtist(artistId, transactionId, (response) => {
        this.logging(response)
        this.artist_data = response
      }, (error) => {
        this.logging(error)
      })
    },
    /**
     * artistIdを使用してアーティストの楽曲を取得
     **/
    getArtistTunes (artistId) {
      this.logging('methods: getArtistTunes()')
      let transactionId = this.$store.state.transactionId
      ArtistService.findArtistTunes(artistId, transactionId, (response) => {
        this.artist_products = response
        this.$store.commit('artistListModuleSetArtistList', response)
      }, (error) => {
        this.logging(error)
      })
    }
  },
  components: {
    MoreBtn,
    Lyrics,
    PlayBtn
  }
}
</script>

<style lang="scss" scoped>
.artistName {
  font-size: 40px;
  font-weight: 300;
  &_sub {
    font-size: 20px;
  }
}

.title_border {
  border-bottom: 3px solid #d6d6d6;
  padding-bottom: 10px;
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/artist/Detail.vue